import { useQuery } from '@tanstack/react-query';
import { getCurrentHomepageApi } from '../helpers/api/portalApi';
import { validate } from 'uuid';

export const HOMEPAGE_KEYS = {
  HOMEPAGE: 'homepage',
};

export const useGetCurrentHomepage = () => {
  return useQuery([HOMEPAGE_KEYS.HOMEPAGE], () => getCurrentHomepageApi(), {
    cacheTime: 0,
    select: getHomepageIdFromUrl,
  });
};

export const getHomepageIdFromUrl = (data: { data: { homepage: string } }): string => {
  const homepageUrl = data?.data?.homepage;
  if (!homepageUrl) return '';

  // Check if the URL matches the /guidelines/guide/:id format
  const guideMatch = homepageUrl.match(/\/guidelines\/guide\/([^/]+)\/?$/);
  if (guideMatch) {
    const id = guideMatch[1];
    return validate(id) ? id : '';
  }

  // Check if the URL matches the /guidelines/home?id=:id format
  const homeMatch = homepageUrl.match(/\/guidelines\/home(?:\?id=([^&]+))?/);
  if (homeMatch) {
    const id = homeMatch[1];
    return validate(id) ? id : '';
  }

  return '';
};
